/**
 * badges/index.jsx
 * Action modifier badges for composite action icons.
 * Each badge provides the visual modifier glyph overlaid at (18, 6) in the 24x24 viewBox.
 */

import * as React from "react";

export const CreateBadge = React.forwardRef(({ className = "", ...props }, ref) => (
  <g ref={ref} className={className} {...props}>
    <path
      d="M18.5 2.7v5.6M15.7 5.5h5.6"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
));
CreateBadge.displayName = "CreateBadge";

export const EditBadge = React.forwardRef(({ className = "", ...props }, ref) => (
  <g ref={ref} className={className} {...props}>
    <path
      d="M16.5 7.5l3.2-3.2 1.2 1.2-3.2 3.2-1.6.4.4-1.6z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
));
EditBadge.displayName = "EditBadge";

export const FilterBadge = React.forwardRef(({ className = "", ...props }, ref) => (
  <g ref={ref} className={className} {...props}>
    <path
      d="M16 3.8h5l-1.9 2.3v2.1l-1.2-.8V6.1z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
));
FilterBadge.displayName = "FilterBadge";

export const SearchBadge = React.forwardRef(({ className = "", ...props }, ref) => (
  <g ref={ref} className={className} {...props}>
    <circle cx="18" cy="5" r="2.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M19.6 6.6l1.7 1.7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </g>
));
SearchBadge.displayName = "SearchBadge";

export const DeleteBadge = React.forwardRef(({ className = "", ...props }, ref) => (
  <g ref={ref} className={className} {...props}>
    <path
      d="M15.7 5.5h5.6"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </g>
));
DeleteBadge.displayName = "DeleteBadge";

export const ScheduleBadge = React.forwardRef(({ className = "", ...props }, ref) => (
  <g ref={ref} className={className} {...props}>
    <path
      d="M18.5 2.7v5.6M15.7 5.5h5.6"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
));
ScheduleBadge.displayName = "ScheduleBadge";

export const LinkBadge = React.forwardRef(({ className = "", ...props }, ref) => (
  <g ref={ref} className={className} {...props}>
    <path
      d="M16.5 7.5l4-4m0 0h-2.8m2.8 0v2.8"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
));
LinkBadge.displayName = "LinkBadge";

export const CheckBadge = React.forwardRef(({ className = "", ...props }, ref) => (
  <g ref={ref} className={className} {...props}>
    <path
      d="M16.2 5.6l1.5 1.6 3.2-3.2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
));
CheckBadge.displayName = "CheckBadge";

export const UpgradeBadge = React.forwardRef(({ className = "", ...props }, ref) => (
  <g ref={ref} className={className} {...props}>
    <path
      d="M18 8v-4.2M15.6 6.2L18 3.8l2.4 2.4"
      stroke="currentColor"
      strokeWidth="2.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
));
UpgradeBadge.displayName = "UpgradeBadge";

export const badgeMap = {
  add: CreateBadge,
  create: CreateBadge,
  edit: EditBadge,
  filter: FilterBadge,
  search: SearchBadge,
  delete: DeleteBadge,
  remove: DeleteBadge,
  schedule: ScheduleBadge,
  link: LinkBadge,
  check: CheckBadge,
  upgrade: UpgradeBadge,
};

export function registerDefaultBadges(registry) {
  for (const [action, Component] of Object.entries(badgeMap)) {
    registry.registerBadge(action, Component);
  }
}
